import { useNavigate } from '@tanstack/react-router';
import { Button, Pictogram, Stack } from '@optimus-web/core';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { useStrictCurrentEnterpriseId } from '@mews-commander/core';
import {
    LinkButton,
    LocalizedPageTitle,
    LocalizedParagraph,
    NewTabLink,
    OptimusProvider,
    OverlayedLoader,
} from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { NewPublicFormWrapper } from '../style';
import { usePasskeyAdd } from '../../../settings/components/Security/Passkeys/usePasskeyAdd';

const PASSKEY_GUIDELINK_URL = createGuideLink(ArticlePath.CreatePasskey);

export const CreatePasskey = () => {
    const currentEnterpriseId = useStrictCurrentEnterpriseId();
    const navigate = useNavigate();

    const onSuccess = () => {
        void navigate({
            to: '/$currentEnterpriseId/Dashboard/Index',
            params: { currentEnterpriseId },
        });
    };

    const { handlePasskeyAdd, isPending } = usePasskeyAdd(onSuccess);

    return (
        <NewPublicFormWrapper vertical>
            <OverlayedLoader show={isPending} />
            <OptimusProvider density="spacious">
                <Stack spacing="500" vertical>
                    <Stack spacing="100" vertical>
                        <Pictogram value="passkey" size="large" />
                        <LocalizedPageTitle textKey={TextKey.CreatePasskeyTitle} />
                        <LocalizedParagraph
                            textKey={TextKey.CreatePasskeyDescription}
                            substitutes={{
                                link: (text) => (
                                    <NewTabLink url={PASSKEY_GUIDELINK_URL} variant="default" inherit={false}>
                                        {text}
                                    </NewTabLink>
                                ),
                            }}
                        />
                    </Stack>

                    <Stack spacing="200" vertical>
                        <Button
                            variant="primary"
                            onClick={handlePasskeyAdd}
                            type="submit"
                            data-test-id="create-passkey"
                        >
                            <LocalizedText textKey={TextKey.CreatePasskeyButtonCta} />
                        </Button>
                        <LinkButton
                            variant="secondary"
                            to="/$currentEnterpriseId/Dashboard/Index"
                            params={{ currentEnterpriseId }}
                            data-test-id="skip"
                        >
                            <LocalizedText textKey={TextKey.CreatePasskeyButtonSkip} />
                        </LinkButton>
                    </Stack>
                </Stack>
            </OptimusProvider>
        </NewPublicFormWrapper>
    );
};
